import './Skills.css';
import rust from '../assets/rust-brands.svg'

const Skills = () => {
  return (
    <section
      data-aos="fade-right"
      className="skills-container"
      name="skills"
      id="skills"
    >
      <h1 className="heading">What I Am Good At &nbsp;&nbsp;?</h1>

      <div className="techs">
        <li>
          <i className="fab html fa-html5"></i> <p>HTML5</p>
        </li>
        <li>
          <i className="fab css fa-css3"></i>
          <p>CSS3</p>
        </li>
        {/* <li>
          <i className="fab sass fa-sass"></i>
          <p>Sass</p>
        </li> */}
        <li>
          <i className="fab bootstrap fa-bootstrap"></i>
          <p>Bootstrap</p>
        </li>
        <li>
          <i className="fab javascript fa-js"></i>
          <p>Javascript</p>
        </li>
        <li>
          <i className="fab react fa-react"></i>
          <p>React</p>
        </li>
        <li>
          <i className="fab typescript fa-react"></i>
          <p>Typescript</p>
        </li>
        <li>
          {/* <i className="fab rust fa-rust">{rust}</i> */}
          <img className="rust" width='70' height='108' src={rust} alt=""/>
           <p>Rust</p>
        </li>
        <li>
          <i className="fab python fa-python"></i>
          <p>Python</p>
        </li>
        <li>
        <i class="fab node fa-node"></i>
        <p>Node Js</p>
        </li>
        <li>
        <img height='108' alt="firebase pic" src="https://img.icons8.com/color/100/000000/firebase.png"/>
        <p>Firebase</p>
        </li>
      </div>
    </section>
  );
};

export default Skills;
